export const visitObjects = {
    de: {
        title: "Besuch",
        titleImage: "./images/visits/besuch.jpg",
        openingHours: [
            {day: "Montag bis Sonntag", hours: "10 Uhr bis 18 Uhr"},
            {day: "Mittwochs", hours: "10 Uhr bis 20 Uhr"},
            {day: "Freitags", hours: "10 Uhr bis 21 Uhr *"},
            {day: "", hours: "*Am 25. August und 15. September schliesst das Museum bereits um 18 Uhr."},
            {day: "365 Tage im Jahr (auch Feiertage)", hours: ""},
        ],
        address: {
            name: "Fondation Beyeler",
            street: "Baselstrasse 101",
            city: "4125 Riehen/Basel",
            country: "Schweiz",
        },
        phone: "+41 61 645 97 00",
        email: "info@fondationbeyeler.ch",
        fax: "+41 61 645 97 19",
        mapImage: "./images/visits/map.png",
        ticketUrl: "/#/eventTicket/1",
    },
    en: {
        title: "Your visit",
        titleImage: "./images/visits/besuch.jpg",
        openingHours: [
            {day: "Monday to Sunday", hours: "10 a.m. – 6 p.m."},
            {day: "Wednesdays", hours: "10 a.m. – 8 p.m."},
            {day: "Fridays", hours: "10 a.m. – 9 p.m. *"},
            {day: "", hours: "*On  August 25 and September 15, the museum closes already at 6 p.m."},
            {day: "365 days a year (including public holidays)", hours: ""},
        ],
        address: {
            name: "Fondation Beyeler",
            street: "Baselstrasse 101",
            city: "4125 Riehen/Basel",
            country: "Switzerland",
        },
        phone: "+41 61 645 97 00",
        email: "info@fondationbeyeler.ch",
        fax: "+41 61 645 97 19",
        mapImage: "./images/visits/map.png",
        ticketUrl: "/#/eventTicket/1",
    },
    fr: {
        title: "Votre visite",
        titleImage: "./images/visits/besuch.jpg",
        openingHours: [
            {day: "Lundi à Dimanche", hours: "10–18 H *"},
            {day: "Mercredi", hours: "10–20 H"},
            {day: "Vendredi", hours: "10h–21h *"},
            {day: "", hours: "*Les 25 août et 15 septembre, le musée ferme ses portes à 18 heures."},
            {day: "365 jours par an (y compris les jours fériés)", hours: ""},
        ],
        address: {
            name: "Fondation Beyeler",
            street: "Baselstrasse 101",
            city: "4125 Riehen/ Bâle",
            country: "Suisse",
        },
        phone: "+41 61 645 97 00",
        email: "info@fondationbeyeler.ch",
        fax: "+41 61 645 97 19",
        mapImage: "./images/visits/map.png",
        ticketUrl: "/#/eventTicket/1",
    },
};
